module.exports = __webpack_public_path__ + "67ae3c27d91fa943c895b1ae7563f091.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/partials/ho-tro-di-dong.jpg
// module id = ./assets/images/partials/ho-tro-di-dong.jpg
// module chunks = 0